<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-terminated',
    }"
  >
    <h4 class="mt-6 mt-9">
      Your account is being setup.
    </h4>
    <p class="p3">
      Your account needs to be validated by an administrator. Someone from our support team will
      reach out to you in the next 24 hours. If this is time sensitive, reach out to us at
      <a href="mailto:support@datapeople.io?subject=SSO%20Locked">
        support@datapeople.io
      </a>
    </p>
  </WizardContent>
</template>

<script>
import WizardContent from '@/components/shared/WizardContent.vue';

export default {
  name: 'SSOLocked',
  components: {
    WizardContent,
  },
  emits: ['track-page-load'],
  beforeCreate() {
    this.$emit('track-page-load', { page: 'SSO Locked' });
  },
};
</script>
